module.exports = __webpack_public_path__ + "img/link.cbe7a778.svg";